import loadable from '@loadable/component';

const LoadingComponentLoadable = loadable(() => import(/* webpackChunkName: "loading-component" */ './index'));

export default LoadingComponentLoadable;
